module.exports = new __parcel__URL__("bug.b594eb39.png").toString();